import { createContext, useContext } from "react";

interface DCOReviewContextType {
  dispute: boolean;
  setDispute: (dispute: boolean) => void;
  currentStep: number;
  goToNextStep: () => void;
  goToPrevStep: () => void;
  goToStep: (step: number) => void;
}

export const DCOReviewContext = createContext<DCOReviewContextType>({
  dispute: false,
  setDispute: () => {},
  currentStep: 0,
  goToNextStep: () => {},
  goToPrevStep: () => {},
  goToStep: () => {},
});

export function useDCOReviewContext() {
  return useContext(DCOReviewContext);
}
